import React from 'react';
import { plural, t } from '@lingui/macro';

import AlertSuccess from '@rover/icons/svg/alert-success.svg';
import ChatInbox from '@rover/icons/svg/chat-inbox.svg';
import Photo from '@rover/icons/svg/photo.svg';
import Rebook from '@rover/icons/svg/rebook.svg';
import Time from '@rover/icons/svg/time.svg';
import { Box, Flex, Heading } from '@rover/kibble/core';
import type { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';
import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';

import SkillItem from './components/SkillItem';
import Skills from './components/Skills';

const CommunicationAndSkills = ({
  info,
  catOnlyProfile = false,
}: {
  info: EnhancedPersonSitterProfile;
  catOnlyProfile?: boolean;
}): JSX.Element | null => {
  const repeatCount = info.providerProfile?.repeatClientCount || 0;

  const { percent, timeUsualDesc: responseText, photoRate } = info.responsiveness;
  const repeatText = repeatCount
    ? plural(repeatCount, { one: '# repeat pet parent', other: '# repeat pet parents' })
    : null;
  const percentText = percent && t`${percent}% response rate`;
  const photoText = photoRate && t`${photoRate}% bookings with photo updates`;

  const usesSvd = getBrandSpecificValue({
    rover: t`Sends updates with Rover Cards`,
    catInAFlat: t`Sends updates with Report Cards`,
  });

  const shouldRenderCommunicationSection =
    repeatText || percentText || responseText || photoText || info.hasUsedSdv;

  if (!shouldRenderCommunicationSection) return null;

  return (
    <Flex flexDirection={['column', 'row', 'column', 'row']} gap="10x" mt="6x">
      <Box width="100%">
        <Heading size="300">{t`Communication`}</Heading>
        {repeatText && <SkillItem icon={Rebook} title={repeatText} />}
        {percentText && <SkillItem icon={ChatInbox} title={percentText} />}
        {responseText && <SkillItem icon={Time} title={responseText} />}
        {photoText && <SkillItem icon={Photo} title={photoText} />}
        {info.hasUsedSdv && <SkillItem icon={AlertSuccess} title={usesSvd} />}
      </Box>
      <Skills catOnlyProfile={catOnlyProfile} info={info} />
    </Flex>
  );
};
export default CommunicationAndSkills;
